const SEPARATE: 'separated' = 'separated'
const TOGETHER: 'together' = 'together'

export const GROUP_PAYMENT_TYPES = {
  SEPARATE,
  TOGETHER,
}
